export default __webpack_public_path__ + "static/media/topship-icon.8c88f2ea.png";